import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  IconButton,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { useQuery } from "react-query";
import { QK } from "../../base/qk";
import { searchClients } from "../../api/services/Client";
import MultiSelect from "../FormFields/CustomSelect/MultiSelect";

const VisitCallModal = ({ show, handleClose }) => {
  const [search, setSearch] = useState("");
  const [selectedClients, setSelectedClients] = useState([]);

  const { data: clients, isLoading } = useQuery(
    [QK.searchClients, search],
    () => searchClients(search),
    { enabled: search.length >= 2 }
  );

  // MultiSelect expects raw objects + getOptionLabel/getOptionValue
  const clientOptions = clients || [];

  const handleSearchChange = (value) => {
    setSearch(value || "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // handle submit with selectedClients
    // console.log("Selected clients:", selectedClients);
    handleClose();
  };

  return (
    <Dialog
      open={show}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { borderRadius: "12px" } }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontWeight: 600,
          pb: 1,
        }}
      >
        Schedule a Visit Call
        <IconButton size="small" onClick={handleClose}>
          <Close fontSize="small" />
        </IconButton>
      </DialogTitle>

      <Box component="form" onSubmit={handleSubmit}>
        <DialogContent sx={{ pt: 2 }}>
          <MultiSelect
            label="Client Name"
            placeholder="Search with at least 2 characters"
            options={clientOptions}
            value={selectedClients}
            onChange={setSelectedClients}
            isLoading={isLoading}
            searchable
            minChars={2}
            onSearchChange={handleSearchChange}
            loadingText="Searching clients..."
            noOptionsText="No clients found"
            getOptionLabel={(c) => `${c.first_name} ${c.last_name}`}
            getOptionValue={(c) => c.id}
            required
          />
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleClose} color="inherit">
            Cancel
          </Button>
          <Button type="submit" variant="contained">
            Submit
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default VisitCallModal;